<template>
	<div class="safetySystem_container">
		<p style="margin: 4rem 0;" class="sub_menu_title">系统架构</p>
		<div class="safetySystem_box_t">
			<div class="safetySystem_box_t_list">
				<div class="sys_box">
					<div>
						<p class="safetySystem_box_t_title">单位领导</p>
						<p class="safetySystem_box_t_msg">单位中的领导可以实时监控数据，检查安全报表信息</p>
					</div>
					<img class="safetySystem_box_t_img" src="../../../assets/static/images/lingdao.png">
				</div>
			</div>
			<div class="safetySystem_box_t_list">
				<div class="sys_box">
					<div>
						<p class="safetySystem_box_t_title">实验室管理员</p>
						<p class="safetySystem_box_t_msg">管理员通过权限调取监控进行安全巡查，拥有门禁权限</p>
					</div>
					<img class="safetySystem_box_t_img" src="../../../assets/static/images/guanli.png">
				</div>
			</div>
			<div class="safetySystem_box_t_list">
				<div class="sys_box">
					<div>
						<p class="safetySystem_box_t_title">科研人员</p>
						<p class="safetySystem_box_t_msg">通过平台上报安全隐患，线上告知管理员</p>
					</div>
					<img class="safetySystem_box_t_img" src="../../../assets/static/images/keyan.png">
				</div>
			</div>
		</div>
		<div class="safetySystem_box_b">
			<div class="safetySystem_box_b_list">
				<div class="sys_box_list">
					<p class="safetySystem_box_b_title">后台管理</p>
					<p class="safetySystem_box_b_msg">后台进行权限分配，电子化管理人员，门禁授权和安全巡查。</p>
				</div>
				<img class="safetySystem_box_b_img" src="../../../assets/static/images/houtai.png" />
			</div>
			<div class="safetySystem_box_b_list">
				<div class="sys_box_list">
					<p class="safetySystem_box_b_title">数据资源</p>
					<p class="safetySystem_box_b_msg">后台对相关数据进行记录与统计，例如对人员流动和环境监测进行统计。</p>
				</div>
				<img class="safetySystem_box_b_img" src="../../../assets/static/images/ziyuan.png" />
			</div>
			<div class="safetySystem_box_b_list">
				<div class="sys_box_list">
					<p class="safetySystem_box_b_title">物联网智能硬件</p>
					<p class="safetySystem_box_b_msg">关联相关硬件：门禁控制器、视频监控、环境湿度检测器或者气体检测器。</p>
				</div>
				<img class="safetySystem_box_b_img" src="../../../assets/static/images/wulian.png" />
			</div>
		</div>
		<div class="safetySystem_service_container">
			<p style="padding: 5rem 0 3.5rem 0;" class="sub_menu_title">业务模块功能</p>
			<div class="safetySystem_service_list">
				<div class="safetySystem_service_box">
					<p class="safetySystem_service_title">安全巡查</p>
					<p  class="safetySystem_service_msg">隐患上报和日常巡查，根据项目整改计划，编写巡查报表</p>
					<img class="safetySystem_service_img" src="../../../assets/static/images/safe.png">
				</div>
				<div class="safetySystem_service_box">
					<p class="safetySystem_service_title">门禁管理</p>
					<p  class="safetySystem_service_msg">门禁授权管理并进行生物特征识别，
系统逻辑鉴权功能并流向管控</p>
					<img class="safetySystem_service_img" src="../../../assets/static/images/keys.png">
				</div>
				<div class="safetySystem_service_box">
					<p class="safetySystem_service_title">视频监控</p>
					<p  class="safetySystem_service_msg">无死角监控、多类型IPC可选，并且实时查看、多屏展示以确保环境安全</p>
					<img class="safetySystem_service_img" src="../../../assets/static/images/video.png">
				</div>
				<div class="safetySystem_service_box">
					<p class="safetySystem_service_title">环境监测</p>
					<p  class="safetySystem_service_msg">环境中温度湿度监测、气体浓度监测和气压监测，异常数据主动预警</p>
					<img class="safetySystem_service_img" src="../../../assets/static/images/wendu.png">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { scrollAnimation } from '../../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.safetySystem_container {
		.safetySystem_box_t {
			display: flex;
			width: 75rem;
			margin: 0 auto;
		}

		.safetySystem_box_t_list {
			width: 24rem;
			height: 13.625rem;
			background: #FFFFFF;
			box-shadow: 0 0.1875rem 0.5rem 0 rgba(175, 175, 175, 0.5);
			margin: 0 1rem;
			padding: 2rem 0;
			padding-left: 1.5rem;
			padding-right: 1.5rem;
			border-radius: 0.5rem;
		}

		.safetySystem_box_t_title {
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
		}

		.safetySystem_box_t_msg {
			font-size: 0.875rem;
			width: 13.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}

		.sys_box {
			display: flex;
			// justify-content: center;
			// align-items: center;
			flex-direction: column;
		}

		.safetySystem_box_t_img {
			align-self: flex-end;
			margin-top: -6rem;
		}

		.safetySystem_box_b {
			display: flex;
			width: 75rem;
			margin: 0 auto;
			margin-top: 1rem;
			justify-content: space-between;
		}

		.safetySystem_box_b_list {
			position: relative;
			margin: 0 1rem;
			text-align: center;
		}

		.sys_box_list {
			position: absolute;
			top: 3rem;
			z-index: 50;
			padding: 0 1.5rem;
		}

		.safetySystem_box_b_msg {
			text-align: left;
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 1.3125rem;
		}

		.safetySystem_box_b_title {
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			margin-top: -1rem;
			padding-bottom: 0.5rem;
		}

		.safetySystem_box_b_img {
			transform: scale(1);
			height: 26.5rem;
			width: 24rem;
			margin-left: -0.7rem;
		}
	}

	.safetySystem_service_container {
		background: #F9FAFC;
		height: 39.4375rem;
		.safetySystem_service_list {
			display: flex;
			width: 75rem;
			margin: 0 auto;
			justify-content: space-between;
		}
		.safetySystem_service_box{
			width: 17.625rem;
			height: 17.625rem;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.5rem 0.1875rem rgba(210,210,210,0.5);
			border-radius: 0.375rem;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: baseline;
			padding: 0 1rem;
			padding-top: 2rem;
		}
		.safetySystem_service_img{
			align-self: flex-end;
			height: 7rem;
			margin-top: 1rem;
		}
		.safetySystem_service_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			line-height: 1.75rem;
		}
		.safetySystem_service_msg{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 1.3125rem;
			}
	}
</style>
